import { Reveal, SectionHeader } from "@/components/shared/Reveal";

const DAYS = [
  ["Torsdag 22 okt", [["23.59", "Anmälan till tävlingen stängs"]]],
  ["Fredag 6 nov", [
    ["08.00", "Förardepåerna öppnar"], ["15.00", "Presskonferens"], ["15.00", "Tävlingscentrum öppnar"],
    ["16.00", "Anmälan förare öppnar"], ["17.00", "Maskinbesiktning öppnar"], ["20.00", "Anmälan förare stänger"],
    ["21.00", "Maskinbesiktning stänger"], ["21.30", "Tävlingscentrum stänger"],
  ]],
  ["Lördag 7 nov", [
    ["06.00", "Tävlingscentrum öppnar"], ["08.00", "Invigning"], ["08.16", "Utsläpp av motorcyklar börjar"],
    ["08.31", "Första start"], ["ca 13.00", "Första förare i mål, dagsetappen"], ["ca 15.00", "Sista förare i mål, dagsetappen"],
    ["16.16", "Utsläpp av motorcyklar börjar"], ["16.31", "Första start, nattetappen"],
  ]],
  ["Söndag 8 nov", [
    ["ca 05.00", "Första förare i mål, nattetappen"], ["ca 07.00", "Sista förare i mål, nattetappen"],
    ["10.00", "Prisutdelning"], ["ca 11.00", "Tävlingscentrum stänger"], ["14.00", "Depåerna öppnar för allmänheten"],
  ]],
];

export const TimeTable2026 = () => (
  <section data-testid="timetable-2026" className="pb-24 sm:pb-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal><SectionHeader kicker="Program" title="Tidsschema Novemberkåsan 2026 (preliminärt)" /></Reveal>
      <div className="mt-10 overflow-x-auto rounded-xl border border-white/8 bg-[#14161A]">
        <table className="w-full text-left text-sm">
          <thead className="font-mono text-[11px] uppercase tracking-widest text-amber-500 border-b border-white/10">
            <tr><th className="hidden sm:table-cell px-4 py-3">Dag</th><th className="px-4 py-3">Klockan</th><th className="px-4 py-3">Händelse</th></tr>
          </thead>
          <tbody>
            {DAYS.map(([day, rows]) => [
              <tr key={day} className="sm:hidden border-t border-white/10">
                <td colSpan={2} className="px-4 pt-3 pb-1 font-semibold text-white">{day}</td>
              </tr>,
              ...rows.map(([time, event], i) => (
              <tr key={day + i} className={i === 0 ? "sm:border-t sm:border-white/10" : ""}>
                <td className="hidden sm:table-cell px-4 py-2.5 align-top font-semibold text-white whitespace-nowrap">{i === 0 ? day : ""}</td>
                <td className="px-4 py-2.5 align-top font-mono text-white/80 whitespace-nowrap">{time}</td>
                <td className="px-4 py-2.5 align-top text-white/70">{event}</td>
              </tr>
            ))])}
          </tbody>
        </table>
      </div>
      <p data-testid="timetable-2026-footer" className="mt-4 text-sm text-white/50">Christer Eriksson, tävlingsledare. Uppdaterad 11 oktober 2026.</p>
    </div>
  </section>
);
